import styled from 'styled-components'
import fondo from '../imgs/fondoregistro.jpg'
import TextField from '@mui/material/TextField';
import CountrySelect from './countrySelect.jsx'
import LoadingButton from '@mui/lab/LoadingButton';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom'
import { useState,useEffect } from 'react'
import api  from "../axios.js"
import Backdrop from '@mui/material/Backdrop';


const Container=styled.div`
	background-color:black;
	height:100vh;
	width:100vw;
	overflow:hidden;
	display:flex;
	align-items:center;
	justify-content:left

;
`
const GamezImg=styled.div`
    z-index:0;
    height:100%;
    border:1px solid black;
    width:75%;
    background-image:url(${fondo});
    background-size:cover;
    background-position:87%;
    position:relative;
    opacity:0.9;
    border-radius:5px;
    
   
`;

const Overlay=styled.div`
	position: absolute;
    width: 100%;
    height: 100%;
    z-index:0;
    background: rgb(0,0,0);
	background: linear-gradient(90deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,1) 100%);
    
    pointer-events: none;
`;

const Logo=styled.div`
	position:absolute;
	color:white;
	right:3vw;
	bottom:5vh;
	display:flex;
	align-items:center;
	justify-content:center;
`;

const ContainerRegistro=styled.div`
	height:94%;
	width:41%;	
	position:absolute;
	font-family: "Poppins", sans-serif;
	background: rgba(1, 1, 1, 0.6); 
  	border-radius: 10px;
  	backdrop-filter: blur(5px);
 	box-shadow: 0 4px 30px #26125D; 
  	border: 1px solid #26125D; 
  	text-align: center;
  	color: white;
  	display:flex;
  	flex-direction:column;
  	align-items:center;
  	justify-content:center;
  	right:1%;
`;

let Titulo=styled.div`
 	font-size:20px;
 	font-weight:bold;
 	width:90%;
 	display:flex;
 	margin-bottom:15px

`;

let RegistroInput=styled.div`
	height:80px;
	display:flex;
	width:85%;
	justify-content:space-between
`;

let MsjValidacionnCorreo=styled.div`

	height:20%;
	width:55%;
	font-family: "Poppins", sans-serif;
	font-size:20px;
	background: rgba(1, 1, 1, 0.6); 
  	border-radius: 10px;
  	backdrop-filter: blur(5px);
 	box-shadow: 0 4px 30px #26125D; 
  	text-align: center;
  	color: white;
  	display:flex;
  	flex-direction:column;
  	align-items:center;
  	justify-content:center;
`;


export default function Registro(){
	let navigate=useNavigate();
	let [ newUser,setNewUser ]=useState({name:"",usuario:"",password:"",tipo:3,correo:"",telefono:"",pais:"",codPais:""});
	let [ validarCorreo,setValidarCorreo ]=useState(false);
	let [ loading , setLoading ]= useState(false); 
	let [ enviado,setEnviado ]=useState(false);

	let Back=()=>{ navigate("/")};


	let handleChange=(e)=>{
		let id=e.target.id;
		let valor=e.target.value;
		if(id!=="nombre"&&id!=='ape1'&&id!=='ape2'){
			setNewUser({...newUser,[id]:valor})
		}else{
			let nombre=document.getElementById("nombre").value.trim();
			let apellido1=document.getElementById("ape1").value.trim();
			let  apellido2=document.getElementById("ape2").value.trim();
			setNewUser({...newUser,name:`${nombre} ${apellido1} ${apellido2}`})
		}
	}

	let handleChangeTelefono=(e)=>{
		let valor=e.target.value;
		if(Number(valor)<999999999){
			setNewUser({...newUser,telefono:String(valor)})
		}
	}

	let paisSelected=(val,newVal)=>{
		if(newVal){
		setNewUser({...newUser,pais:newVal.label,codPais:`+${newVal.phone}`})
		}else{setNewUser({...newUser,pais:"",codPais:` `})}
	};


	let crear=async()=>{

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if(newUser.name&&newUser.usuario&&newUser.password&&newUser.telefono&&newUser.pais&&newUser.codPais&&emailRegex.test(newUser.correo) ){
			setLoading(true);
			setNewUser({...newUser,telefono:`${newUser.codPais}${newUser.telefono}`});
			if(window.confirm('deseas regitrar estos datos?')){
				try{
					await api.post("/usuario/solicita",{newUser});
				alert('datos enviados, revisa tu correo para confirmar la activacion');
				setValidarCorreo(true);
				setLoading(false);
				setEnviado(true);
				alert("revisa tu correo para validar la activacion");
				}catch(err){setLoading(false);console.log(err);alert(`${err.response.data}`)}
			}
		}else{alert('verifica q los datos esten llenos de manera correcta')}


	}

	useEffect(()=>{console.log(newUser)},[newUser])

	return(
		<Container>
			<Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={validarCorreo}  > 
		  				
		  		{validarCorreo?<MsjValidacionnCorreo>
		  							<div>Revisa tu correo, y confirma la activacion de la cuenta</div>
		  							<LoadingButton  loading={loading} endIcon={<ArrowBackIcon/>} size="small" color="error" onClick={Back}>regresar a tienda</LoadingButton>
		  						</MsjValidacionnCorreo>:null}
		  				
     	 	</Backdrop>
			<GamezImg>
				 <Overlay/>
			</GamezImg>
				<ContainerRegistro>
				<Titulo>
					CREAR CUENTA
				</Titulo>
				<RegistroInput>
					<label >Nombres :</label><TextField onChange={handleChange} size="small" id="nombre" variant="standard"color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >Apellido Paterno :</label><TextField onChange={handleChange} size="small" id="ape1" variant="standard" color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >Apellido materno :</label><TextField onChange={handleChange} size="small" id="ape2"variant="standard" color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >Correo :</label><TextField onChange={handleChange} size="small" id="correo" variant="standard" color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >usuario :</label><TextField onChange={handleChange} size="small" id="usuario" variant="standard" color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >contraseña :</label><TextField onChange={handleChange} size="small" id="password" variant="standard" color="secondary" sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >Telefono :</label><TextField onChange={handleChangeTelefono} size="small" type="number" id="telefono" variant="standard" color="secondary" value={newUser.telefono} sx={{width:"50%"}}/>
				</RegistroInput>
				<RegistroInput>
					<label >Pais :</label><CountrySelect paisSelected={paisSelected} id="pais" color="secondary" />
				</RegistroInput>
				<RegistroInput>
				{enviado?null:<div>
					<LoadingButton  loading={loading}  endIcon={<ManageAccountsIcon/>} size="small" onClick={crear} >Crear</LoadingButton>
					<LoadingButton  loading={loading} endIcon={<ArrowBackIcon/>} size="small" color="error" onClick={Back}>regresar a tienda</LoadingButton>
				</div>}				
				</RegistroInput>
				<Logo><b>Playlan</b>myn™</Logo>
			</ContainerRegistro>
			
			
			
		</Container>
		)
}